// extracted by mini-css-extract-plugin
export default {"Cell":"Cell_Cell__mEO0Y"};